import { MasterOutletUpdate } from '@app/api/models/acb';

export const CHANNELS_PROCESS_TYPE = 'channels';

/** Поля, которые может менять заявка с типом процесса «Каналы». */
export const CHANNEL_PROCESS_FIELDS = ['sub_channel_id'] as const;

export const isChannelsProcess = (update?: Pick<MasterOutletUpdate, 'process_type'> | null) =>
  update?.process_type === CHANNELS_PROCESS_TYPE;

const pickChannelFields = <T extends object>(data: T | null | undefined): T | null | undefined => {
  if (!data) { return data; }
  return Object.fromEntries(
    Object.entries(data).filter(([key]) => (CHANNEL_PROCESS_FIELDS as readonly string[]).includes(key)),
  ) as T;
};

/**
 * В заявку «Каналы» могут попасть изменения других полей (имя, адрес, дистрибьюторы и т.д.).
 * Такие изменения не показываем и не применяем — оставляем только канал/подканал.
 * Backend при применении (outlet/update_request/channels/save/) их тоже отбрасывает.
 */
export const onlyProcessFields = (update: MasterOutletUpdate): MasterOutletUpdate => {
  if (!isChannelsProcess(update)) { return update; }
  return {
    ...update,
    data: pickChannelFields(update.data) as MasterOutletUpdate['data'],
    data_before: pickChannelFields(update.data_before),
  };
};
